import { Client, Features } from '@weenat/client'
import { getToken, getUserLanguage } from 'app/state'
import isNil from 'lodash-es/isNil'
import { CURRENT_ORG_KEY } from './orgProvider'

const optionalHeader = (key: string, value?: string | null | number) =>
  !isNil(value) ? { [key]: `${value}` } : {}

export const makeClient = (featureFlags: Features, loginAs: { email: string; id: number } | null) =>
  Client(() => {
    const language = getUserLanguage()
    const token = getToken()
    const apiHost = `${import.meta.env.VITE_API_HOST}/api`
    return {
      protocol: import.meta.env.VITE_API_PROTOCOL as 'https',
      host: apiHost,
      hosts: {
        api: apiHost,
        tiles: import.meta.env.VITE_TILES_API_HOST,
        dss: import.meta.env.VITE_DSS_API_HOST,
        ts: import.meta.env.VITE_TS_API_HOST
      },
      headers: {
        // Important to omit the whole authorization header if we have no token otherwise the backend will not decode the token
        ...optionalHeader('authorization', !isNil(token) ? `JWT ${token}` : undefined),
        ...optionalHeader('x-weenat-login-as', loginAs?.email),
        ...optionalHeader('x-weenat-login-as-uid', loginAs?.id),
        ...optionalHeader('x-weenat-target-org', localStorage.getItem(CURRENT_ORG_KEY)),
        ...optionalHeader('accept-language', language)
      },
      featureFlags
    }
  })
